import { gql } from '@apollo/client';
import { AccountDeliveryDriverType } from '../../types/AccountDeliveryDriverType';

export const GET_ACCOUNT_DELIVERY_DRIVERS_BY_IDS = gql`
    query GetAccountDeliveryDriversByIds($accountIds: [Long!]!) {
        getAccountDeliveryDriversByIds(accountIds: $accountIds) {
            id
            accountId
            dspId
            driverLicenseNumber
            vehicleTypeId
            vehiclePlate
            isOnDuty
            vehicleImageS3KeysJson
            vehicleImageUrls
            idDocumentType
            idDocumentNumber
            idDocumentImageS3KeysJson
            idDocumentImageUrls
            createdAt
            updatedAt
            account {
                id
                name
                countryCode
                phone
                email
                status
            }
            dsp {  
                id
                name
                dspCode
            }
        }
    }
`;

export interface GetAccountDeliveryDriversByIdsResponse {
    getAccountDeliveryDriversByIds: AccountDeliveryDriverType[];
}

export const getAccountDeliveryDriversByIds = async (accountIds: number[]): Promise<AccountDeliveryDriverType[]> => {
    const { client } = await import('../../../../../graphql/client');
    const result = await client.query({
        query: GET_ACCOUNT_DELIVERY_DRIVERS_BY_IDS,
        variables: { accountIds },
        fetchPolicy: 'network-only'
    });
    return result.data.getAccountDeliveryDriversByIds;
};

